'use es6';

import { Component } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import PropTypes from 'prop-types';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';

// Legacy stuff
import OldIndexControllerBusEventHandlers from 'ContentEditorUI/legacyHoldingPattern/oldIndexControllerBusEventHandlers';
import withEditorActionsAndEvents from 'ContentEditorUI/components/hoc/withEditorActionsAndEvents';
import { validate } from '../redux/actions/postPublishActions';
import SaveShortcutChecker from 'ContentEditorUI/coffee/lib/SaveShortcutChecker';
import { processFakeModulesOffOfContentSchema } from '../redux/actions/postContentModelActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state)
});
const mapDispatchToProps = {
  validate,
  processFakeModulesOffOfContentSchema
};
class LegacyBlogScaffoldComponent extends Component {
  componentDidMount() {
    const {
      saveActions,
      bus
    } = this.props;

    // Legacy, unported logic pushed to the side for now
    const oldIndexControllerBusEventHandlers = new OldIndexControllerBusEventHandlers(this.storeRef, saveActions, bus);
    this.props.processFakeModulesOffOfContentSchema();
    SaveShortcutChecker.listenForSaveRequest(() => saveActions.save());
    oldIndexControllerBusEventHandlers.registerAllLegacyEvents();
    this.props.validate();
  }

  // This should only ever be rendered once
  shouldComponentUpdate() {
    return false;
  }
  saveStoreRefAndReturnNull(store) {
    this.storeRef = store;
    return null;
  }
  render() {
    return /*#__PURE__*/_jsx(ReactReduxContext.Consumer, {
      children: ({
        store
      }) => this.saveStoreRefAndReturnNull(store)
    });
  }
}
LegacyBlogScaffoldComponent.propTypes = {
  validate: PropTypes.func.isRequired,
  saveActions: PropTypes.object.isRequired,
  processFakeModulesOffOfContentSchema: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withEditorActionsAndEvents(LegacyBlogScaffoldComponent));